(function ($) {
  pcgProductMobileSKUV1 = {
    formatter: $('.pcg-product-mobile-sku')
  };

  Drupal.behaviors.pcgProductMobileSKUV1 = {
    get: function (key) {
      return pcgProductMobileSKUV1[key];
    },

    set: function (key, val) {
      pcgProductMobileSKUV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
      });
    }
  };
})(jQuery);
